import { Component } from '@angular/core';

@Component({
  selector: 'pds-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: false,
})
export class FormComponent {}
